document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.video-gallery');
  const modalEl = section.querySelector('modal-dialog.modal--video');
  const playerContainer = modalEl.querySelector('.video-modal-player');
  const metaEl = modalEl.querySelector('.video-modal-meta');
  const productsEl = modalEl.querySelector('.video-modal-products');
  const closeBtn = modalEl.querySelector('.modal__close-btn');

  // Open modal when play button clicked
  section.addEventListener('click', e => {
    const btn = e.target.closest('.video-play-button');
    if (!btn) return;

    const slide = btn.closest('.video-slide');
    if (!slide) return;

    openModal(
      slide.querySelector('.video-data'),
      slide.dataset.videoSrc,
      slide.dataset.videoType
    );
  });

  // Lazy-load videos and iframes
  const lazyVideos = section.querySelectorAll('.lazy-video');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const src = el.getAttribute('data-src');
        if (!src) return;

        if (el.tagName === 'VIDEO') {
          el.src = src;
          el.load();
          el.play().catch(() => {});
        } else if (el.tagName === 'IFRAME') {
          el.src = src;
        }

        obs.unobserve(el);
      });
    }, { rootMargin: '100px 0px', threshold: 0.1 });

    lazyVideos.forEach(el => observer.observe(el));
  } else {
    lazyVideos.forEach(el => {
      const src = el.getAttribute('data-src');
      if (src) el.src = src;
    });
  }

  // Open modal implementation
  function openModal(dataEl, src, type) {
    document.body.classList.add('no-scroll');
    // Render media
    if (type === 'mp4') {
      playerContainer.innerHTML = `
        <video
          src="${src}"
          controls autoplay loop playsinline disablepictureinpicture disableremoteplayback
          controlslist="nodownload nofullscreen noremoteplayback noplaybackrate"
          style="object-fit:cover;width:100%;height:100%">
        </video>`;
    } else {
      playerContainer.innerHTML = `
        <iframe
          src="${src}"
          frameborder="0"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowfullscreen
          style="object-fit:cover;width:100%;height:100%">
        </iframe>`;
    }

    // Populate meta and products
    metaEl.innerHTML =
      dataEl.querySelector('.video-data-title').outerHTML +
      dataEl.querySelector('.video-data-description').outerHTML;
    productsEl.innerHTML = '';
    dataEl.querySelectorAll('.video-data-products > *').forEach(el => {
      productsEl.appendChild(el.cloneNode(true));
    });

    // Show modal-dialog
    modalEl.classList.remove('invisible');
    modalEl.setAttribute('open', '');
  }

  // Close modal implementation
  function closeModal() {
    modalEl.removeAttribute('open');
    modalEl.classList.add('invisible');
    document.body.classList.remove('no-scroll');
    playerContainer.innerHTML = '';
  }

  // Close events
  closeBtn.addEventListener('click', closeModal);
  modalEl.addEventListener('click', e => {
    if (e.target === modalEl) closeModal();
  });

});